export const SUBTASK_FIELD_IDS = [
	'issuekey',
	'summary',
	'issuetype',
	'status',
	'priority',
	'assignee',
	'parent',
] as const;
export const QUERY_NAME = 'getJiraBoardIssueSubtasks';
